import { Link } from 'react-router-dom';

export default function Footer() {
  const footerLinks = {
    platform: [
      { name: 'Church Directory', href: '/directory' },
      { name: 'Worship Operations', href: '/worship' },
      { name: 'Live Sabbath', href: '/live' },
      { name: 'Ministry Profiles', href: '/ministries' },
    ],
    resources: [
      { name: 'Media Library', href: '/media' },
      { name: 'Downloadables & Toolkits', href: '/toolkits' },
      { name: 'Regional Hubs', href: '/regional' },
      { name: 'Doctrine Framework', href: '/resources' },
    ],
    leadership: [
      { name: 'Leadership Dashboard', href: '/leadership' },
      { name: 'Analytics & Insights', href: '/leadership' },
      { name: 'Governance Tools', href: '/governance' },
      { name: 'Help Center', href: '/help' },
    ],
    organization: [
      { name: 'About ATAN', href: '/about' },
      { name: 'Contact Us', href: '/contact' },
      { name: 'Privacy Policy', href: '/privacy' },
      { name: 'Terms of Service', href: '/terms' },
    ],
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 sm:gap-10 lg:gap-12 mb-8 sm:mb-12">
          <div className="space-y-4 lg:col-span-1">
            <div className="flex items-center space-x-3">
              <img 
                src="https://static.readdy.ai/image/b26ccc3ae7fa45b3398224fbc482abd6/074d3102ffad2a455591f49f105c88ed.png" 
                alt="SDAChurch Worship Hub" 
                className="h-10 sm:h-12 w-auto"
              />
              <div className="flex flex-col">
                <span className="text-sm sm:text-base font-semibold" style={{ fontFamily: 'Noto Sans, system-ui, sans-serif' }}>
                  Worship Hub
                </span>
                <span className="text-xs text-gray-400">SDA Churches in Nigeria</span>
              </div>
            </div>
            <p className="text-xs sm:text-sm text-gray-400 leading-relaxed">
              National digital worship infrastructure for the Seventh-day Adventist Church in Nigeria, coordinated by ATAN.
            </p>
            <div className="flex space-x-3 sm:space-x-4">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-lg transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg sm:text-xl"></i>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-lg transition-colors cursor-pointer">
                <i className="ri-twitter-x-fill text-lg sm:text-xl"></i>
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-lg transition-colors cursor-pointer">
                <i className="ri-youtube-fill text-lg sm:text-xl"></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-lg transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-lg sm:text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm sm:text-base font-semibold mb-3 sm:mb-4">Platform</h4>
            <ul className="space-y-2 sm:space-y-3">
              {footerLinks.platform.map((link) => (
                <li key={link.name}>
                  <Link to={link.href} className="text-xs sm:text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm sm:text-base font-semibold mb-3 sm:mb-4">Resources</h4>
            <ul className="space-y-2 sm:space-y-3">
              {footerLinks.resources.map((link) => (
                <li key={link.name}>
                  <Link to={link.href} className="text-xs sm:text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm sm:text-base font-semibold mb-3 sm:mb-4">Leadership</h4>
            <ul className="space-y-2 sm:space-y-3">
              {footerLinks.leadership.map((link) => (
                <li key={link.name}>
                  <Link to={link.href} className="text-xs sm:text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm sm:text-base font-semibold mb-3 sm:mb-4">Organization</h4>
            <ul className="space-y-2 sm:space-y-3">
              {footerLinks.organization.map((link) => (
                <li key={link.name}>
                  <Link to={link.href} className="text-xs sm:text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="pt-6 sm:pt-8 border-t border-gray-700">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0 gap-4">
            <p className="text-xs sm:text-sm text-gray-400 text-center md:text-left">
              © 2025 Worship Hub Nigeria. Coordinated by ATAN. All rights reserved.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6">
              <Link to="/terms" className="text-xs sm:text-sm text-gray-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                Terms of Service
              </Link>
              <Link to="/privacy" className="text-xs sm:text-sm text-gray-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                Privacy Policy
              </Link>
              <a href="https://www.adventistng.tech" target="_blank" rel="noopener noreferrer" className="text-xs sm:text-sm text-gray-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                ATAN www.adventistng.tech
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
